import { Action } from '@ngrx/store';
import { User } from '../../models/user.model';

export const GET_USER = '[User] Get User';
export const GET_USER_SUCCESS = '[User] Get User Success';
export const GET_USER_FAIL = '[User] Get User Fail';
export const INACTIVE_USER = '[User] Inactive';

export class GetUser implements Action {
  readonly type = GET_USER;
}

export class GetUserSuccess implements Action {
  readonly type = GET_USER_SUCCESS;
  constructor(public payload: User) {}
}

export class InactiveUser implements Action {
  readonly type = INACTIVE_USER;
  constructor(public payload: User) {}
}

export class GetUserFail implements Action {
  readonly type = GET_USER_FAIL;
  constructor(public payload) {}
}

export type UserActions = GetUser | GetUserSuccess | GetUserFail | InactiveUser;
